// extracted by mini-css-extract-plugin
export var active = "_ab-d";
export var blink = "_ab-e";
export var container = "_ab-5";
export var controls = "_ab-0";
export var controlsRight = "_ab-1";
export var fakeCursor = "_ab-c";
export var hidden = "_ab-b";
export var quillContainerSmall = "_ab-7";
export var quillEditor = "_ab-6";
export var quillEditorSmall = "_ab-8";
export var quillFormatButtons = "_ab-a";
export var quillToolbar = "_ab-9";
export var removePadding = "_ab-2";
export var state = "_ab-3";
export var stateTitle = "_ab-4";